import React, { useMemo } from 'react';
import { TestSuite } from 'store/src/lib/tests/entity';
import isTestFieldRequired from '@app.raytd.com/common/utils/test-suites/getFieldRequirement';
import { getRatingLabel } from '@/app/features/reports/ratingHelpers';
import TextTile from './text-with-label';
import { PASS_COLOR, FAIL_COLOR } from '../../utils/passFailColors';

function Result(props: ResultProps) {
    const { testSuite, result, resultDescription } = props;

    const { displayLabel, headingStyle } = useMemo(() => {
        const isRatingRequired = testSuite
            ? isTestFieldRequired(testSuite, 'rating')
            : false;

        const hasResult = !!result;

        if (!hasResult && !isRatingRequired) {
            return {
                displayLabel: 'Not Applicable',
                headingStyle: {},
            };
        }

        const rawLabel = result
            ? getRatingLabel(testSuite, result)
            : getRatingLabel(testSuite, '');

        const normalisedLabel = rawLabel.toLowerCase();

        if (normalisedLabel === 'compliant') {
            return {
                displayLabel: rawLabel,
                headingStyle: { color: PASS_COLOR },
            };
        }

        if (normalisedLabel === 'not compliant') {
            return {
                displayLabel: rawLabel,
                headingStyle: { color: FAIL_COLOR },
            };
        }

        return {
            displayLabel: rawLabel,
            headingStyle: {},
        };
    }, [result, testSuite]);

    const descriptionLines = useMemo(() => {
        if (!resultDescription) return [];
        return resultDescription.replace(/\\n/g, '\n').split('\n');
    }, [resultDescription]);

    return (
        <TextTile title="Test Result">
            <div className="font-medium mb-1" style={headingStyle}>
                {displayLabel}
            </div>

            {descriptionLines.length > 0 && (
                <div className="space-y-1 text-sm flex-grow whitespace-pre-wrap">
                    {descriptionLines.map((line, index) => (
                        <p key={index}>{line}</p>
                    ))}
                </div>
            )}
        </TextTile>
    );
}

export default Result;

interface ResultProps {
    testSuite: TestSuite;
    result: string | null | undefined;
    resultDescription?: string | null;
}

